if (!customElements.get('header-promo-slider')) {
  class HeaderPromoSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.watchDrawer();
    }

    connectedCallback() {
      this.style.display = 'block';
      this.style.width = '100%';
    }

    initSlider() {
      if (typeof Swiper === 'undefined') {
        return;
      }

      if (this.slider) {
        this.slider.update();
        return;
      }

      this.slider = new Swiper(this, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        watchOverflow: true,
        resistanceRatio: 0.72
      });
    }

    watchDrawer() {
      const details = this.closest('details');

      if (!details) {
        this.initSlider();
        return;
      }

      const updateSlider = () => {
        if (!details.classList.contains('menu-opening')) {
          return;
        }

        requestAnimationFrame(() => {
          this.initSlider();
        });
      };

      const observer = new MutationObserver(updateSlider);
      observer.observe(details, {
        attributes: true,
        attributeFilter: ['class']
      });

      if (details.classList.contains('menu-opening')) {
        updateSlider();
      }
    }
  }

  customElements.define('header-promo-slider', HeaderPromoSlider);
}
